import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ProfileResponse, ProfileUpdate } from "../interfaces/perfil-user.interfaces";
import { AuthService } from "../../../core/service/auth.service";
import { environment } from "../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})

export class PerfilUserService {
  constructor(private http: HttpClient,
    private authservice: AuthService
  ) { }

  getProfile(): Observable<ProfileResponse> {
    const user = this.authservice.getToken();
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${user}`
    });

    return this.http.get<ProfileResponse>(`${environment.apiUrl}/profile/get`, { headers });
  }


  updateProfile(data: ProfileUpdate
  ): Observable<ProfileResponse> {
    const user_token = this.authservice.getToken();
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${user_token}`
    });
    return this.http.patch<ProfileResponse>(`${environment.apiUrl}/profile/update`, data, { headers });
  }
}